// extracted by mini-css-extract-plugin
export default {"wrapper":"bottomNavbar_wrapper__HNXS8","title":"bottomNavbar_title__WJi5B","overlay":"bottomNavbar_overlay__ukZOe"};